import { useContext } from "react";
import { useMatch } from "react-router";
import { REPORT_PAGES_ROUTES } from "../../constants";
import { ReportContext } from "../context";
const useIsReportRoute = () => {
    const { routerRootPath } = useContext(ReportContext);
    const isRoot = Boolean(useMatch({
        path: routerRootPath,
        end: true,
    }));
    const isFileBrowser = Boolean(useMatch({
        path: `${routerRootPath}/${REPORT_PAGES_ROUTES.FILE_BROWSER_ROUTE}`,
        end: false,
    }));
    const isNestedFileBrowser = Boolean(useMatch({
        path: `${routerRootPath}/${REPORT_PAGES_ROUTES.FILE_BROWSER_ROUTE}/:fileId/*`,
        end: false,
    }));
    return { isRoot, isFileBrowser, isNestedFileBrowser };
};
export default useIsReportRoute;
//# sourceMappingURL=useIsReportRoute.js.map